export const environment = {
  production: true,
  Modules: {
    account_payable: false,
    account_recievable: false,
    adt: true,
    ambulance: true,
    billing: true,
    biomedicalwaste: true,
    cash_book: false,
    chiropractic: false,
    cssd: false,
    daycare: true,
    dental: false,
    dietkitchen: true,
    emergency: false,
    fixed_asset: false,
    general_ledger: false,
    housekeeping: true,
    inventory: true,
    ipd: false,
    lab: true,
    linen_laundry: false,
    master: true,
    reports: true,
    mrd: true,
    ncp: false,
    opd: true,
    operation_theatre: false,
    pharmacy: true,
    procurement: true,
    queue_management: false,
    rehab: false,
    usermanagement: true,
    welfare: false,
    generalmaintenance: true,
    doctorshare: true,
    emrlite: false,
    ris: false,
    dpms: false,
    fis_integration: false,
    roster: false,
    generic_lab: false,
    sample_tracking: false,
    quality_control: false,
    quality_system: false,
    barcode: false,
    fixed_assets: false,
    crm: true, 
    moh:false,
    mortuary:true,
    queuemanagement: true,
    counsellinglist: true,
    radiology: true,
    claim: true
  },
  client_name: "dev",
  showPushNotification: false,
  isUserNameAndPasscodeLogin: false
};
